'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import SubscriptionTypeSelect from 'FormsUI/components/common/SubscriptionTypeSelect';
import RichTextEditor from 'FormsUI/loadable/AsyncRichTextEditor';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `formsLegalText.communicationCheckbox.${suffix}`;
export default class CommunicationConsentCheckbox extends PureComponent {
  /* eslint-disable-next-line hubspot-dev/no-static-get-default-props */
  static get defaultProps() {
    return {
      selectedSubscriptionIds: [],
      subscriptionIdsToHide: []
    };
  }
  maybeRenderRequiredToggle() {
    const {
      consentCheckbox,
      onChange
    } = this.props;
    return /*#__PURE__*/_jsx(FormControl, {
      children: /*#__PURE__*/_jsx(Checkbox, {
        checked: consentCheckbox.required,
        id: "required-field",
        onChange: () => onChange(Object.assign({}, consentCheckbox, {
          required: !consentCheckbox.required
        })),
        size: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editor.form.config.requiredField"
        })
      })
    });
  }
  render() {
    const {
      index,
      consentCheckbox,
      consentCheckbox: {
        communicationTypeId = '',
        label = ''
      },
      onChange,
      onDelete,
      isDeletable,
      onBlur,
      errorProps,
      selectedSubscriptionIds,
      subscriptionIdsToHide,
      ungatedForSubscriptionGroups
    } = this.props;
    const idsToHide = [...subscriptionIdsToHide, ...selectedSubscriptionIds.filter(id => id !== communicationTypeId)];
    const maybeDeleteButton = isDeletable ? /*#__PURE__*/_jsx(Link, {
      "data-action": "delete-consent-checkbox",
      onClick: onDelete,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('delete')
      })
    }) : null;
    const handleSubscriptionChange = ({
      id
    }) => {
      onChange(Object.assign({}, consentCheckbox, {
        communicationTypeId: id
      }));
    };
    return /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('header'),
        options: {
          count: index + 1
        }
      }),
      help: maybeDeleteButton,
      "data-test-id": communicationTypeId,
      children: /*#__PURE__*/_jsx(Tile, {
        compact: true,
        distance: "small",
        children: /*#__PURE__*/_jsxs(TileSection, {
          children: [/*#__PURE__*/_jsx(FormControl, {
            children: /*#__PURE__*/_jsx(SubscriptionTypeSelect, {
              hideIds: idsToHide,
              value: communicationTypeId,
              onChange: handleSubscriptionChange,
              isUngatedForSubscriptionGroups: ungatedForSubscriptionGroups
            })
          }), /*#__PURE__*/_jsx(FormControl, Object.assign({
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('checkboxLabel')
            })
          }, errorProps, {
            children: /*#__PURE__*/_jsx(RichTextEditor, {
              content: label,
              onChange: value => {
                onChange(Object.assign({}, consentCheckbox, {
                  label: value
                }));
              },
              onBlur: onBlur,
              isSingleLine: true,
              config: "GDPR"
            })
          })), this.maybeRenderRequiredToggle()]
        })
      })
    });
  }
}
CommunicationConsentCheckbox.propTypes = {
  isDeletable: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  consentCheckbox: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    required: PropTypes.bool,
    communicationTypeId: PropTypes.number
  }).isRequired,
  subscriptionIdsToHide: PropTypes.array.isRequired,
  selectedSubscriptionIds: PropTypes.array.isRequired,
  subscriptionDefinition: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }),
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  ungatedForSubscriptionGroups: PropTypes.bool.isRequired,
  errorProps: PropTypes.object
};